<p-table #tableBuilder class="t-builder" [columns]="selectColumns" [value]="data()" [loading]="loading()" [globalFilterFields]="filterFields()" [paginator]="true"
    [rows]="20" [rowsPerPageOptions]="[10,20,50]" [responsive]="true">

    <ng-template #caption>
        <div class="d-flex">
            <p-iconfield iconPosition="left" class="ml-auto">
                <p-inputicon styleClass="pi pi-search">
                </p-inputicon>
                <input pInputText type="text" placeholder="Buscar..." (input)="tableBuilder.filterGlobal($any($event.target).value, 'contains')" />
            </p-iconfield>
        </div>
        <div class="mt-2 w-25">
            <label for="columnSelect">Seleccionar Columnas:</label>
            <p-multiselect id="columnSelect" display="chip" [options]="columns()" [(ngModel)]="selectColumns"
            optionLabel="header" selectedItemsLabel="{0} columnas seleccionadas" [style]="{ 'min-width': '100px' }" placeholder="Seleccionar Columnas" ></p-multiselect>
        </div>
    </ng-template>
    

    <ng-template #header let-columns>
        <tr>
            <th class="text-sm text-nowrap" *ngFor="let col of columns">
                {{ col.header }}
            </th>
        </tr>
    </ng-template>
    <ng-template #body let-rowData let-columns="columns">
        <tr>
            <td class="text-sm text-truncate" *ngFor="let col of columns">
                {{ rowData[col.field] }}
            </td>
        </tr>
    </ng-template>

</p-table>